import _intersection from 'lodash/intersection';
import { ReactNode } from 'react';
import { Navigate, To } from 'react-router-dom';
import { useActiveCompany } from '~/hooks/useActiveCompany';
import { RouteConfig } from '~/routes/routeConfig';
import { LeadSource } from '~/types/company';

interface Props {
  children: ReactNode;
  forbiddenLeadSources: LeadSource[];
  redirectTo?: To;
}

/**
 * Guard that restricts access based on the company's lead source.
 * If the company's lead source is in the forbiddenLeadSources array,
 * the user will be redirected to the specified route or the app root.
 *
 * @param children
 * @param forbiddenLeadSources
 * @param redirectTo
 * @constructor
 */
const LeadSourceGuard: React.FC<Props> = ({ children, forbiddenLeadSources, redirectTo }) => {
  const company = useActiveCompany();

  if (company.leadSource && forbiddenLeadSources.includes(company.leadSource)) {
    return <Navigate replace to={redirectTo ?? RouteConfig.AppRoot.buildLink()} />;
  }

  return <>{children}</>;
};

export default LeadSourceGuard;
